module.exports = __webpack_public_path__ + "img/users.f684b429.svg";